import React, { useEffect, useState } from 'react';
import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import CitologiaLaminasContainer from './content/citologia.container';
import IntlMessage from "../../helpers/intlMessage";
import { useIntl } from 'react-intl';

function CitologiaPage (props) {
  const intl = useIntl();
  const [currentTab, setCurrentTab] = useState('0');

  useEffect(() => {
    setTimeout(() => {
      setCurrentTab('1');
    }, 200);
  }, []);

  const mudarAba = (event, tab) => {
    setCurrentTab(tab);
  };

  return (
    <div className='mv-histologia-page'>
      <TabContext value={currentTab}>
        <AppBar position='static' color='default'>
          <Tabs
            value={currentTab}
            onChange={mudarAba}
            variant='scrollable'
            //scrollButtons='on'
            indicatorColor='primary'
            textColor='primary'
            aria-label='scrollable force tabs example'
          >
            <Tab
              icon={<i className='tab-icons fas fa-disease'></i>}
              label={<IntlMessage id = "dashboards.cytology.geral"/>}
              value='1'
            />

            <Tab value='0' disabled></Tab>
          </Tabs>
        </AppBar>

        <TabPanel value='0'></TabPanel>
        <TabPanel value='1'>
          <CitologiaLaminasContainer {...props} intl={intl}/>
        </TabPanel>
      </TabContext>
    </div>
  );
}

export default CitologiaPage;



// WEBPACK FOOTER //
// ./src/pages/citologia/citologia.page.js